import { Component, EventEmitter, input, Output, forwardRef, signal } from '@angular/core';
import { SelectComponent, SelectOptionComponent } from '../select.component';
import { Comparator } from "../../../models/enums";
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-select-comparator',
  imports: [FormsModule, SelectComponent, SelectOptionComponent],
  templateUrl: './select-comparator.component.html',
  styleUrl: './select-comparator.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComparatorComponent),
      multi: true
    }
  ]
})
export class SelectComparatorComponent implements ControlValueAccessor {
  disabled = input<boolean>(false);
  allowLessThanOrEqual = input<boolean>(true);
  allowGreaterThanOrEqual = input<boolean>(true);

  @Output('selectedValueChange') selectedValueChangeEmitter = new EventEmitter<Comparator>();

  Comparator = Comparator;

  // Internal model for ngModel binding
  internalModel = signal<Comparator>(Comparator.GreaterThanOrEqual);

  private onChange = (value: Comparator) => {};
  private onTouched = () => {};

  // ControlValueAccessor implementation
  writeValue(value: Comparator): void {
    this.internalModel.set(value);
  }

  registerOnChange(fn: (value: Comparator) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // Input signals are read-only, so we can't set them directly
    // The disabled state is handled by the parent component
  }

  onModelChange(value: string | undefined) {
    if (value !== undefined) {
      const comparatorValue = value as Comparator;
      this.onChange(comparatorValue);
      this.onTouched();
      this.selectedValueChangeEmitter.emit(comparatorValue);
    }
  }
}
